import { render, staticRenderFns } from "./EMensagemAlerta.vue?vue&type=template&id=1b3d9d80"
import script from "./EMensagemAlerta.vue?vue&type=script&lang=js"
export * from "./EMensagemAlerta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports